import React from "react";
import { AlertTriangle } from "lucide-react";

export default function NoAccessCard({ label }: { label: string }) {
  return (
    <div className="bg-white border rounded-xl p-8 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-amber-50 border border-amber-100">
          <AlertTriangle className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <div className="font-semibold text-gray-900">Access restricted</div>
          <div className="text-sm text-gray-600 mt-1">{label}</div>
        </div>
      </div>
    </div>
  );
}
